import { useMemo } from 'react';
import Tabs from 'src/components/primitives/Tabs/Tabs';
import { TabOption } from 'src/components/primitives/Tabs/types';

import { APPKIT_SOCIAL_WALLET_PROVIDER_NAME } from 'src/constants/wallets';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

export type AccountTabsValue = 'accounts' | 'wallet';

export const AccountTabs = ({
	selectedTab,
	setSelectedTab,
}: {
	selectedTab: AccountTabsValue;
	setSelectedTab: (tab: AccountTabsValue) => void;
}) => {
	const wallet = useVelocityStore((s) => s.wallet);
	const isAppKitWallet = useVelocityStore((s) => s.wallet.isAppKit);
	const isSocialAppKitWallet =
		isAppKitWallet &&
		wallet?.current?.adapter?.name === APPKIT_SOCIAL_WALLET_PROVIDER_NAME;
	const isExternalWallet = isSocialAppKitWallet;

	const tabs = useMemo(() => {
		return [
			{
				label: 'Accounts',
				value: 'accounts',
			},
			...(isExternalWallet
				? [
						{
							label: 'Wallet',
							value: 'wallet' as AccountTabsValue,
						},
					]
				: []),
		] satisfies TabOption<AccountTabsValue>[];
	}, [isExternalWallet]);

	if (tabs.length === 1) {
		return null;
	}

	return (
		<Tabs
			options={tabs}
			activeTab={selectedTab}
			onTabChange={(tab) => setSelectedTab(tab)}
		/>
	);
};
